import { FC, useEffect } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { CheckInfoType } from 'adapters/types';
import { EVENT_NAME } from 'common/constants';
import { useAmplitude } from 'components/AmplitudeProvider';
import { ComposedTable } from 'components/ComposedTable';
import { getChecksFailedFormatted } from 'pages/VendorsTablePage/components/PrintChecks';
import { DEFAULT_COL_WIDTH } from 'pages/VendorsTablePage/components/VendorsTable/constants';
import { useAppSelector } from 'store/hooks';
import { amplitudeTracker } from 'utils/AmplitudeTracker';
import { FAILURE_DIALOG_TABLE_HEIGHT } from './constants';
import { failedPrintChecksColumns } from './failedPrintChecksColumns';
import { StyledDialogContainer, StyledDialogCard } from './styled';

export const PrintFailureTable: FC = () => {
  const intl: IntlShape = useIntl();
  const failedChecks = useAppSelector(getChecksFailedFormatted);
  const amplitude = useAmplitude();

  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    if (failedChecks.length)
      amplitudeTracker(amplitude, EVENT_NAME.PrintChecksFailure, {
        'Property Description': failedChecks.length
      });
  }, [failedChecks]);

  return (
    <StyledDialogContainer>
      <StyledDialogCard>
        <ComposedTable<CheckInfoType>
          columnDefs={failedPrintChecksColumns(intl)}
          defaultColDef={{
            minWidth: DEFAULT_COL_WIDTH,
            sortable: false
          }}
          isDownloadable={false}
          isPrintable={false}
          isSearchable={false}
          onGridSizeChanged={({ api }) => api.sizeColumnsToFit()}
          pagination={false}
          rowData={failedChecks}
          suppressPaginationPanel
          useCustomHeader
          customHeight={FAILURE_DIALOG_TABLE_HEIGHT}
          hideTableBorder
        />
      </StyledDialogCard>
    </StyledDialogContainer>
  );
};
